import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=1687a091"
import script from "./Agent.vue?vue&type=script&lang=ts"
export * from "./Agent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1687a091')) {
      api.createRecord('1687a091', component.options)
    } else {
      api.reload('1687a091', component.options)
    }
    module.hot.accept("./Agent.vue?vue&type=template&id=1687a091", function () {
      api.rerender('1687a091', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Agent.vue"
export default component.exports